module.exports = __webpack_public_path__ + "aaea53ea6a3f30e8b9d029bb71e61e86.svg";